<template>
  <div class="container">
    <el-row>
      <el-col :span="3">
        <cma-catalog :site-type="this.site_type" :project-id="this.project_id" :site-id="this.site_id"
                     :rr-type="this.rr_type" title="原始记录（CMA）"
                     :route-name="'site_'+this.site_type+'_list'"></cma-catalog>
      </el-col>
      <el-col :span="21">
        <Toolbar
            :inspectStatus=inspect_status
            :buttons="[
              // {text:'保存', type: 'success', onClick: handleSubmit},
              {text:'提交审核', type: 'primary', onClick: handleSubmitSh}
            ]"
            :currentRoute="currentRoute"
            :projectId="project_id"
            :siteId="site_id"
            :siteType="site_type"
        />
        <hr>
        <el-form :model="form">
          <table>
            <tr>
              <td colspan="3"><p style="font-size: 48px;text-align: center">建 筑 电 气 防 火 检 测 <br> 原
                始 记 录</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>项目名称：</p>
              </td>
              <td>
                <el-input v-model="form.project_name"></el-input>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <p>项目地址：</p>
              </td>
              <td>
                <el-input v-model="form.project_address"></el-input>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <p>检测时间：</p>
              </td>
              <td>
                <el-date-picker style="width: 100%" v-model="form.jcsj"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <p>检测人员：</p>
              </td>
              <td>
                <el-select disabled
                           v-model="form.jcry"
                           multiple
                           filterable
                           default-first-option
                           placeholder="请选择检测人员" style="width: 100%">
                  <el-option v-for="item in project_employee_options" :key="item.value"
                             :label="item.label"
                             :value="item.label">
                  </el-option>
                </el-select>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <p>报告编号：</p>
              </td>
              <td>
                <el-input v-model="form.report_code"></el-input>
              </td>
              <td></td>
            </tr>
          </table>
          <br>
          <table>
            <tr>
              <td><p style="font-size: 20px">主&nbsp;&nbsp;&nbsp;检：</p></td>
              <td>
                <el-select disabled
                           v-model="form.zj"
                           multiple
                           filterable
                           default-first-option
                           placeholder="请选择人员" style="width: 100%">
                  <el-option v-for="item in project_employee_options" :key="item.value"
                             :label="item.label"
                             :value="item.label">
                  </el-option>
                </el-select>
              </td>
              <td><p style="font-size: 20px">日期：</p></td>
              <td>
                <el-date-picker style="width: 100%"
                                v-model="form.zjrq"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                </el-date-picker>
              </td>
              <td></td>
            </tr>
            <tr>
              <td><p style="font-size: 20px">记录员：</p></td>
              <td>
                <el-select disabled
                           v-model="form.jly"
                           multiple
                           filterable
                           default-first-option
                           placeholder="请选择人员" style="width: 100%">
                  <el-option v-for="item in project_employee_options" :key="item.value"
                             :label="item.label"
                             :value="item.label">
                  </el-option>
                </el-select>
              </td>
              <td><p style="font-size: 20px">日期：</p></td>
              <td>
                <el-date-picker style="width: 100%"
                                v-model="form.jlyrq"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                </el-date-picker>
              </td>
              <td></td>
            </tr>
            <tr>
              <td><p style="font-size: 20px">审&nbsp;&nbsp;&nbsp;核：</p></td>
              <td>
                <el-select disabled
                           v-model="form.sh"
                           filterable
                           default-first-option
                           placeholder="请选择审核人员" style="width: 100%">
                  <el-option v-for="item in project_employee_options" :key="item.value"
                             :label="item.label"
                             :value="item.label">
                  </el-option>
                </el-select>
              </td>
              <td><p style="font-size: 20px">日期：</p></td>
              <td>
                <el-date-picker style="width: 100%"
                                v-model="form.shrq"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                </el-date-picker>
              </td>
              <td></td>
            </tr>
            <tr>
              <td><p style="font-size: 20px">审&nbsp;&nbsp;&nbsp;批：</p></td>
              <td>
                <el-select disabled
                           v-model="form.sp"
                           filterable
                           default-first-option
                           placeholder="请选择审批人员" style="width: 100%">
                  <el-option v-for="item in project_employee_options" :key="item.value"
                             :label="item.label"
                             :value="item.label">
                  </el-option>
                </el-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Vue from "vue";
import RouteSelector from "@/components/RouteSelector.vue";
import Toolbar from "@/components/Toolbar.vue";

export default {
  components: {Toolbar, RouteSelector},
  data() {
    return {
      currentRoute: 'record_cma_index',
      inspect_status:false,
      site_id: '',
      project_id: '',
      site_type: '',
      rr_type: 'record',
      form: {
        project_name: '',
        project_address: '',
        jcsj: '',
        jcry: [],
        zj: [],
        jly: [],
        zjrq: '',
        jlyrq: '',
        sh: '',
        shrq: '',
        sp: '',
        sprq: '',
      },
      project_employee_options: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  methods: {
    async getData() {
      try {
        let params = {
          project_id: this.project_id,
          site_id: this.site_id
        }
        let res = await this.$Api.post('get_record_cma_index', params)
        if (res) {
          this.form = res
          this.form.jcry = res.jcry.split(',')
          this.form.zj = res.zj.split(',')
          this.form.jly = res.jly.split(',')
          if (res.site_address) {
            this.form.project_address = res.site_address
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    handleSubmit() {
      if (this.form.hasOwnProperty("id")) {
        this.onEdit()
      } else {
        this.onAdd()
      }
    },
    async onEdit() {
      try {
        let params = this.form
        params.project_id = this.project_id
        params.site_id = this.site_id
        params.zj = this.form.zj.toString()
        params.jcry = this.form.jcry.toString()
        params.zj = this.form.zj.toString()
        params.jly = this.form.jly.toString()
        params.jcsj = this.form.jcsj.toString().replace(',', '至')
        await this.$Api.post('edit_record_cma_index', params)
        await this.getData()
        this.$message.success('修改成功')
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async onAdd() {
      try {
        let params = this.form
        params.project_id = this.project_id
        params.site_id = this.site_id
        params.jcry = this.form.jcry.toString()
        params.jcsj = this.form.jcsj.toString().replace(',', '至')
        await this.$Api.post('add_record_cma_index', params)
        await this.getData()
        this.$message.success('新增成功')
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //获取场所信息
    async handleGetSiteInfo() {
      try {
        let res = await this.$Api.post('get_site_detail', {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type
        })
        if (res) {
          this.form.project_name = res.project_name
          this.form.report_code = res.report_code
          this.form.project_address = res.site_address
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //提交审核
    handleSubmitSh() {
      this.$confirm('提交审核之后原始记录不可修改，确认提交审核？', '确认审核', {
        confirmButtonClass: '确认',
        cancelButtonClass: '取消',
        type: 'warning'
      }).then(
          async () => {
            try {
              await this.$Api.post('check_record_cma', {
                project_id: this.project_id,
                site_id: this.site_id,
                site_type: this.site_type
              })
              this.$message.success('提交成功')
              location.reload()
            } catch (e) {
              this.$message.error(e.errormsg)
            }
          }
      )
    },
    //获取人员下拉
    async getEmployeeOptions() {
      try {
        let res = await this.$Api.post('get_project_employee_options', {project_id: this.project_id})
        if (res) {
          this.project_employee_options = res
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },

    //设置操作按钮的状态
    async setButtonStatus() {
      try {
        let res = await this.$Api.post('get_site_status', {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type,
          status_type: 'cma'
        })
        if (res) {
          if (res === '检测中' || res === '已完成') {
            let res2 = await this.$Api.post('get_site_employees', {
              project_id: this.project_id,
              site_id: this.site_id,
            })
            if (res2) {
              let current_employee_name = Vue.$Config.userinfo.employee_name
              if (res2.jc_users.split(',').includes(current_employee_name) ||
                  res2.zj.split(',').includes(current_employee_name) ||
                  res2.jly.split(',').includes(current_employee_name)||
                  current_employee_name==='管理员'
              ) {
                this.inspect_status = true
              }
            }
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    }
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.setButtonStatus()
    this.getEmployeeOptions()
    this.getData()
  }
}
</script>
<style scoped>
table {
  width: 100%;
}

table tr td:first-child {
  width: 20%;
}

table tr td:last-child {
  width: 10%;
}

table td:first-child {
  text-align: right;
  font-size: 22px;
}

table td {
  text-align: left;
  font-size: 22px;
}


</style>
